module.exports = __webpack_public_path__ + "img/muriae.873ed69f.png";